import Button from "@/common/components/Button";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useMaintenanceDirectiveDiagnosticEntryAdvance } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/directive/diagnosticEntries/useMaintenanceDirectiveDiagnosticEntryAdvance";
import { useForwardingTabContext } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/useForwardingTabContext";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

const DirectiveEntryDiagnosticEntriesAdvance = () => {
  const { forwarding } = useForwardingTabContext();

  const { id } = useParams();

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: advance,
    isPending: advanceIsPending,
  } = useMaintenanceDirectiveDiagnosticEntryAdvance({
    directiveEntryId: forwarding?.directive_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        });

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Button
        variant="success"
        onClick={() => advance()}
        isLoading={advanceIsPending}
        operationKlassToCheckPermission="Admin::Maintenance::Directive::DiagnosticEntries::Advance"
      >
        Aprovar
      </Button>

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DirectiveEntryDiagnosticEntriesAdvance;
